import React from 'react';
import { colors } from 'styleguide';

import { IconProps } from './types';

const Dash = ({ size = 20, color = colors('neutral', 3) }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line x1="7" y1="10" x2="13" y2="10" stroke={color} strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export default Dash;
